import React, { useState } from "react";
import AccordionItem from "./AccordionItem";
import styles from "./AccordionCategory.module.css";
import { toggleNode } from "./accordionTree.helpers.js";

const AccordionCategory = ({
  categoryId,
  categoryName,
  subCategories,
  selectedValues,
  onSelectionChange,
  isOrange,
  disabled,
}) => {
  const [open, setOpen] = useState(false);

  const handleToggle = (node) => {
    const updatedTree = toggleNode(selectedValues, node);
    onSelectionChange(categoryId, updatedTree);
  };

  return (
    <div className={styles.accordionWrapper}>
      <div
        className={`${styles.header} ${isOrange ? styles.orange : ""}`}
        onClick={() => setOpen(!open)}
      >
        <span>{categoryName}</span>
        <span>{open ? "▲" : "▼"}</span>
      </div>

      {open && (
        <div className={styles.body}>
          {subCategories.map((node) => (
            <AccordionItem
              key={node.id}
              node={node}
              tree={selectedValues}
              onToggle={handleToggle}
              disabled={disabled}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AccordionCategory;
